var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("news-list", {
        staticClass: "d-none d-lg-block",
        attrs: {
          articles: _vm.articlesLg,
          "max-columns": 8,
          "columns-per-item": this.colsLg
        }
      }),
      _vm._v(" "),
      _c("news-list", {
        staticClass: "d-none d-md-block d-lg-none",
        attrs: {
          articles: _vm.articlesMd,
          "max-columns": 12,
          "columns-per-item": this.colsMd
        }
      }),
      _vm._v(" "),
      _c("news-list", {
        staticClass: "d-block d-md-none",
        attrs: {
          articles: _vm.articlesSm,
          "max-columns": 12,
          "columns-per-item": this.colsSm
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }